module.exports = __webpack_public_path__ + "static/img/20220209-172120.52e8c623.png";